exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.contract-view .active-user-indicator {\n  display: none;\n}\n.contract-view .is-active-user .active-user-indicator {\n  display: inline-block;\n}\n.contract-view .disputing-old-value {\n  margin-top: 6px;\n  font-size: 14px;\n  opacity: 0.5;\n}\n.contract-view .disputing-old-value::before {\n  content: \"(\\E04\\E48\\E32\\E40\\E14\\E34\\E21: \";\n}\n.contract-view .disputing-old-value::after {\n  content: \")\";\n}\n.contract-view .disputing-old-value-2 {\n  margin-top: 6px;\n  font-size: 14px;\n  opacity: 0.5;\n}", ""]);

// exports
